import Loader from '@repo/ui/loader'
import { useRef, useState } from 'react'

import { API } from '../../../api/apis.config'
import FilterDrawer from '../../../components/elements/drawers/filter-drawer'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import { countFilters } from '../../../components/elements/dynamic-table/utils/countFilters'
import withPeriods, { WithPeriodsProps } from '../../../components/hoc/with-periods'
import { OlCommissionsFilter } from '../../../components/pages/ols/ol-commissions/ol-commissions-filter'
import useAuth from '../../../lib/hooks/use-auth'
import { useFilters } from '../../../lib/hooks/use-filters'
import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import useTranslate from '../../../lib/hooks/use-translate'
import {
  OlCommission,
  OlCommissionFilters
} from '../../../lib/types/models/ol/commission/ol-commission'
import { PeriodProperties } from '../../../lib/types/models/period/period.properties'
import {
  transformOlCommissionFiltersToUrl,
  transformUrlToOlCommissionFilters
} from '../../../lib/utils/filters-mapping/ol-commission'
import { getCommissionColumns } from './utils'

const commissionsInitialFilters: OlCommissionFilters = {}

const FeesCommissionsListPage = ({ periods }: WithPeriodsProps) => {
  const tableRef = useRef<DynamicTableRef<OlCommission>>(null)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const { user } = useAuth()
  const { t } = useTranslate()
  const { modalState, toggleModal, closeModel } = useModalManager<'filters'>(['filters'])

  const { selectedFilter, filter, onFilterChange, resetFilters, onSelectedFilterChange } =
    useFilters<OlCommissionFilters>({
      initialFilters: {
        ...commissionsInitialFilters,
        olId: user?.ol?.id,
        periods: PeriodProperties.getCurrentYearPeriods(periods ?? []).map((period) => period.id)
      },
      options: { allowSearchParam: true },
      transformFilterToUrl: transformOlCommissionFiltersToUrl,
      transformUrlToFilter: transformUrlToOlCommissionFilters
    })

  const olId = user?.ol?.id

  if (!olId) return <Loader />

  return (
    <div>
      <DynamicDataTable<OlCommission, OlCommissionFilters>
        ref={tableRef}
        onLoadingChange={setIsTableLoading}
        title={'Commissions'}
        isSearchable={false}
        permissions={{ delete: false }}
        columns={getCommissionColumns('FEES', t)}
        allowSearchParam
        endpoint={API.ols.getOlCommissionsByOl.url.replace(':olId', olId.toString())}
        filters={selectedFilter}
        filtersLength={countFilters(selectedFilter, ['olId'])}
        onFiltersClick={() => toggleModal('filters')}
      />

      {/* Filters Modal */}
      <FilterDrawer<OlCommissionFilters>
        isOpen={modalState.filters}
        selectedFilter={selectedFilter}
        isLoading={isTableLoading}
        onClose={() => closeModel('filters')}
        onReset={resetFilters}
        onApply={() => onSelectedFilterChange({ ...filter })}
        onFilterChange={onFilterChange}
      >
        <OlCommissionsFilter filter={filter} onFilterChange={onFilterChange} />
      </FilterDrawer>
    </div>
  )
}

export default withPeriods(FeesCommissionsListPage)
